import { VELOCIDADES_DISPONIVEIS, type Timeline, type VelocidadeTimeline } from './useTimeline'

const ROTULO_VELOCIDADE: Record<VelocidadeTimeline, string> = {
  0.25: '0,25×',
  0.5: '0,5×',
  1: '1×',
}

/** Play, pause, reset, scrub e velocidade. A câmera continua livre enquanto pausado. */
export function ControlesTimeline({ timeline, fase, marcos }: { timeline: Timeline; fase?: string; marcos?: readonly number[] }) {
  return (
    <div className="grupo-controle reproducao">
      <span className="titulo-controle">Reprodução</span>
      {fase && <p className="fase-atual">{fase}</p>}
      <input
        aria-label="Instante da animação"
        type="range"
        min="0"
        max="1"
        step="0.001"
        value={timeline.tempo}
        onChange={(e) => timeline.irPara(Number(e.target.value))}
      />
      <div className="linha-botoes">
        <button onClick={() => timeline.voltarEtapa(marcos)}>Etapa anterior</button>
        <button className="primario" onClick={timeline.alternarReproducao}>
          {timeline.reproduzindo ? 'Pausar' : 'Reproduzir'}
        </button>
        <button onClick={() => timeline.avancarEtapa(marcos)}>Próxima etapa</button>
        <button onClick={timeline.reiniciar}>Reiniciar</button>
      </div>
      <div className="grade-velocidade">
        {VELOCIDADES_DISPONIVEIS.map((v) => (
          <button
            key={v}
            className={timeline.velocidade === v ? 'ativo' : ''}
            onClick={() => timeline.definirVelocidade(v)}
          >
            {ROTULO_VELOCIDADE[v]}
          </button>
        ))}
      </div>
      <p className="dica">Pause para orbitar a cena sem perder o instante.</p>
    </div>
  )
}
